import { useState } from 'react';
import InventorySimplifiedView from './InventorySimplifiedView';
import { useTranslation } from 'react-i18next';
import useIsMobileDisplay from '../../../../hooks/useIsMobileDisplay';
import { Popup, Button } from 'semantic-ui-react';
import { VIEW_MODE, MOBILE } from '../../../../constants';
import useInventoryShort from '@behavior/inventories/getInventoryShort';
import { compose } from 'redux';
import { connect } from 'react-redux';

const InventoryOverviewPopup = ({
  entityType,
  handleDefaultFilteredListOverride,
  entityId,
  redirectHandler,
  isCanModifyAsCreator,
  isEditor,
  showPersonalData,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobileDisplay();
  const [inventory, setInventory] = useState();
  const { getInventoryShort } = useInventoryShort(entityId);

  const handlePopupOpen = (entityId, mode) => {
    setIsOpen(true);
    getInventoryShort(entityId).then(data => {
      if (data) {
        setInventory(data);
      }
    });
  };

  const getClassName = () => {
    let className = 'mouseCursorPointer';
    if (!isEditor) {
      return className;
    }
    return className.concat(isCanModifyAsCreator ? ' zoomButton' : ' zoomButton2');
  };

  const handlePopupClose = () => {
    setInventory();
    setIsOpen(false);
  };

  return (
    <div>
      <InventorySimplifiedView
        displayInventroyDetails={inventory}
        isOpen={isOpen}
        handlePopupClose={handlePopupClose}
        showPersonalData={showPersonalData}
        trigger={
          <Popup
            key={entityId + 'details'}
            trigger={
              <Button
                type="button"
                color="blue"
                icon="zoom-in"
                className={getClassName()}
                disabled={false}
                onClick={() => {
                  if (!isMobile) {
                    entityType === 'inventory'
                      ? handlePopupOpen(entityId, VIEW_MODE)
                      : redirectHandler(entityType, VIEW_MODE);
                  } else {
                    entityType === 'inventory'
                      ? redirectHandler(entityType, MOBILE)
                      : redirectHandler(entityType, VIEW_MODE);
                  }
                }}
              />
            }
            size="mini"
            content={t('inventory.overview.page.table.container.view.record.tooltip')}
            position="top left"
          />
        }
        handleDefaultFilteredListOverride={handleDefaultFilteredListOverride}
        entityId={entityId}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  showPersonalData: state.dataPrivacy.showPersonalData,
});

export default compose(connect(mapStateToProps, null))(InventoryOverviewPopup);
